/* eslint-disable import/prefer-default-export */
export const unitConstants = {

  GETALL_REQUEST: 'UNITS_GETALL_REQUEST',
  GETALL_SUCCESS: 'UNITS_GETALL_SUCCESS',
  GETALL_FAILURE: 'UNITS_GETALL_FAILURE',
  UNLOAD_UNITS: 'UNITS_UNLOAD_UNITS',

  SET_TRACKER_REQUEST: 'UNITS_SET_TRACKER_REQUEST',
  SET_TRACKER_SUCCESS: 'UNITS_SET_TRACKER_SUCCESS',
  SET_TRACKER_FAILURE: 'UNITS_SET_TRACKER_FAILURE',

  GET_TRACKER_REQUEST: 'UNITS_GET_TRACKER_REQUEST',
  GET_TRACKER_SUCCESS: 'UNITS_GET_TRACKER_SUCCESS',
  GET_TRACKER_FAILURE: 'UNITS_GET_TRACKER_FAILURE',

  SET_SELECTED_UNIT: 'UNITS_SET_SELECTED_UNIT',
  UNSET_SELECTED_UNIT: 'UNITS_UNSET_SELECTED_UNIT',

  TOGGLE_DIALOG: 'UNITS_TOGGLE_DIALOG',

  SET_ALL_UNITS_DONE: 'UNITS_SET_ALL_UNITS_DONE',
};
